import * as React from 'react';

const SvgChannelPartner = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M5.333 19.5a2.5 2.5 0 0 0-2.5 2.5h5a2.5 2.5 0 0 0-2.5-2.5ZM9.5 22h5a2.5 2.5 0 0 0-5 0ZM16.167 22h5a2.5 2.5 0 0 0-5 0ZM5.333 19.083a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM12 19.083a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM18.667 19.083a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM12.275 8.25h-1.942a.833.833 0 0 0 0 1.667h.625a.208.208 0 0 1 .209.208v.208a.833.833 0 0 0 1.666 0v-.216a.208.208 0 0 1 .192-.209A1.525 1.525 0 0 0 14.5 8.25c0-.992-.992-1.667-2.033-2.358-.25-.167-.592-.4-.834-.6a.208.208 0 0 1-.075-.234.216.216 0 0 1 .2-.141h1.909a.833.833 0 0 0 0-1.667h-.625a.208.208 0 0 1-.209-.208v-.209a.833.833 0 1 0-1.666 0v.217a.208.208 0 0 1-.192.208A1.5 1.5 0 0 0 9.5 4.917c0 .991.992 1.666 2.033 2.358.25.167.592.4.834.6a.208.208 0 0 1-.092.375ZM5.333 14.917a.833.833 0 0 0 .834-.834v-.208a.208.208 0 0 1 .208-.208h4.583a.208.208 0 0 1 .209.208v.208a.834.834 0 0 0 1.666 0v-.208a.208.208 0 0 1 .209-.208h4.583a.208.208 0 0 1 .208.208v.208a.833.833 0 0 0 1.667 0v-1.25a.833.833 0 0 0-.833-.833H5.333a.833.833 0 0 0-.833.833v1.25a.833.833 0 0 0 .833.834Z" />
    </svg>
  );
};

export default SvgChannelPartner;
